/**
 * DebugStartGameButton — the debug panel's "Start Game" testing aid.
 *
 * Shown only while the debug panel is open (\) and the latest roomStatus says
 * the server will accept a force start (canForceStart: non-production, room
 * WAITING, 2+ players). The server makes that decision; this only mirrors it.
 *
 * The debug panel itself is drawn on the Pixi canvas, which can't host a
 * clickable control, so this is a DOM button positioned just below it.
 */
const DebugStartGameButton = {
  button: null,
  onForceStart: null,
  debugPanelVisible: false,
  canForceStart: false,

  init({ onForceStart } = {}) {
    this.button = document.getElementById('debugStartGameButton');
    this.onForceStart = onForceStart || null;
    this.debugPanelVisible = false;
    this.canForceStart = false;
    if (!this.button) return;

    // Mouse input is read from document-level listeners; keep presses on this
    // button from also firing the player's weapon.
    for (const type of ['mousedown', 'mouseup', 'pointerdown', 'pointerup']) {
      this.button.addEventListener(type, (e) => e.stopPropagation());
    }
    this.button.addEventListener('click', (e) => {
      e.stopPropagation();
      if (this.button.disabled) return;
      this.button.blur(); // don't let Space/Enter re-trigger it or swallow game keys
      this.button.disabled = true; // one request per room status
      this.onForceStart?.();
    });

    this._render();
  },

  setDebugPanelVisible(visible) {
    this.debugPanelVisible = Boolean(visible);
    this._render();
  },

  setRoomStatus(roomData) {
    this.canForceStart = roomData?.canForceStart === true;
    if (this.button) this.button.disabled = false;
    this._render();
  },

  _render() {
    if (!this.button) return;
    this.button.classList.toggle('hidden', !(this.debugPanelVisible && this.canForceStart));
  }
};

export { DebugStartGameButton };
